import uuidv4 from "uuid/v4";

export function addNewPeopleTransformation(requests, payload) {
    let newPeople = {
        id: uuidv4(),
        name: payload.email,
        email: payload.email,
        status: payload.status,
        course: payload.course
    };
    return (
        [...requests, newPeople]
    )
}

export function cancelRequestsPeopleTransformation(requests, payload) {
    return (
        [...requests.filter((item) => item.id !== payload)]
    )
}




// WEBPACK FOOTER //
// ./src/utils/addPeopleTransformation.js